import { render, staticRenderFns } from "./ProductCampaignForm.vue?vue&type=template&id=19e19c40"
import script from "./ProductCampaignForm.vue?vue&type=script&lang=js"
export * from "./ProductCampaignForm.vue?vue&type=script&lang=js"
import style0 from "./ProductCampaignForm.vue?vue&type=style&index=0&id=19e19c40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports